export default "__VITE_ASSET__CHxqbn2p__"